import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from './api.service'
 
@Injectable({ providedIn: 'root' })
export class StatusServices {
    private statusMap = {};
    public Status: string
    constructor(private api: ApiService) {
        this.api.getAllStatus().subscribe(response => {
            if (Array.isArray(response)) {
                response.forEach(ele => {
                    this.statusMap[ele.statusCode] = ele.statusDescription;
                });
                localStorage.setItem("statusList", JSON.stringify(response));
            }
        });
    }
 
    getStatus(status) {
        return this.statusMap[status]
    }
}